import angular = require("angular");
import { DropdownOptionsService } from "@services/clients/dropdownOptions.service";

export interface ClientFilters {
  displayMyClients: boolean;
  displayInstitutions: boolean;
  displayIndividuals: boolean;
  hasTradeRestrictions?: boolean;
  selectedGeographicalLocations?: number[];
  selectedProfessionalActivities?: number[];
  selectedSecurityRestrictions?: number[];
}

class ClientsFilterModalController implements angular.IComponentController {
  static $inject = ["dropdownOptionsService"];

  public filters: ClientFilters;
  public isClientDetailsViewOnly: boolean;
  public dropdownOptions: any;
  public onFiltersApplied: (params: { filters: ClientFilters }) => void;
  public onFiltersCancelled: () => void;
  public securitySearchText: string = "";

  private originalFilters: ClientFilters;

  constructor(
    private dropdownOptionsService: DropdownOptionsService
  ) {}

  $onInit() {
    // Create a copy of the original filters for cancellation
    this.originalFilters = {
      displayMyClients: this.filters.displayMyClients,
      displayInstitutions: this.filters.displayInstitutions,
      displayIndividuals: this.filters.displayIndividuals,
      hasTradeRestrictions: this.filters.hasTradeRestrictions,
      selectedGeographicalLocations: this.filters.selectedGeographicalLocations ? [...this.filters.selectedGeographicalLocations] : [],
      selectedProfessionalActivities: this.filters.selectedProfessionalActivities ? [...this.filters.selectedProfessionalActivities] : [],
      selectedSecurityRestrictions: this.filters.selectedSecurityRestrictions ? [...this.filters.selectedSecurityRestrictions] : []
    };

    // Load dropdown options
    this.loadDropdownOptions();
  }

  private loadDropdownOptions() {
    this.dropdownOptionsService.getAllOptions()
      .then((options) => {
        this.dropdownOptions = options;
      })
      .catch((error) => {
        console.warn('Failed to load dropdown options:', error);
      });
  }

  public applyFilters() {
    if (this.onFiltersApplied) {
      console.log("this.filters in modal", this.filters);
      this.onFiltersApplied({ filters: this.filters });
    }else{
      console.log("no onFiltersApplied method in modal");
    }
  }

  public clearSecuritySearchTerm() {
    this.securitySearchText = "";
  }

  public cancelFilters() {
    // Restore original filter values
    this.filters.displayMyClients = this.originalFilters.displayMyClients;
    this.filters.displayInstitutions = this.originalFilters.displayInstitutions;
    this.filters.displayIndividuals = this.originalFilters.displayIndividuals;
    this.filters.hasTradeRestrictions = this.originalFilters.hasTradeRestrictions;
    this.filters.selectedGeographicalLocations = this.originalFilters.selectedGeographicalLocations ? [...this.originalFilters.selectedGeographicalLocations] : [];
    this.filters.selectedProfessionalActivities = this.originalFilters.selectedProfessionalActivities ? [...this.originalFilters.selectedProfessionalActivities] : [];
    this.filters.selectedSecurityRestrictions = this.originalFilters.selectedSecurityRestrictions ? [...this.originalFilters.selectedSecurityRestrictions] : [];
    
    if (this.onFiltersCancelled) {
      this.onFiltersCancelled();
    }
  }
}

export const clientsFilterModal: angular.IComponentOptions = {
  template: require("./clients-filter-modal.component.html"),
  controller: ClientsFilterModalController,
  bindings: {
    filters: "<",
    isClientDetailsViewOnly: "<",
    onFiltersApplied: "&",
    onFiltersCancelled: "&"
  }
};



// WEBPACK FOOTER //
// ./src/app/clients/modals/clients-filter-modal.component.ts